export default __webpack_public_path__ + "static/media/11.574e16c5.jpg";